export enum TagEvent {
  CREATE_NEW_TAG = 'CREATE_NEW_TAG',
  UPDATE_TAG = 'UPDATE_TAG',
  DELETE_TAG = 'DELETE_TAG',
}

export default TagEvent;
